'use client'

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ErrorMessage, useField } from "formik";

interface TProps {
	id?: string;
	label?: string;
	type?: string;
	name: string;
	placeholder?: string;
	disabled?: boolean;
	value?: any
    onChange?: (e: any) => void;
}

const FormikInput = ({ id, label, ...props }: TProps) => {
	const [field, meta] = useField(props);
	const hasError = meta.touched && !!meta.error;

	return (
		<div className="grid w-full gap-3">
			{label &&
				<Label htmlFor={id} className={`${hasError && "text-red-500"}`}>
					{label}
				</Label>
			}
			<div>
				<Input
					{...field}
					{...props}
					className={`${hasError && "border-red-500"}`}
				/>
				<ErrorMessage
					name={field.name}
					component="p"
					className="mt-1 text-sm font-semibold text-red-500"
				/>
			</div>
		</div>
	);
};

export default FormikInput;
